import { Link, useLocation } from "react-router-dom";
import { slide as Menu } from "react-burger-menu";
import { useState } from "react";
import "../css/Navbar.css";
import { FaFacebook, FaInstagram } from "react-icons/fa";
import "animate.css";
function Navbar() {
    const location = useLocation();

    const [isMenuOpen, handleMenu] = useState(false);
    const handleCloseMenu = () => {
        handleMenu(false);
    };
    const handleStateChange = (state) => {
        handleMenu(state.isOpen);
    };

    return (
        <>
            <nav
                className={`absolute top-0 z-30 w-full py-2 animate__animated animate__fadeInDown ${
                    location.pathname === "/contact"
                        ? "bg-black/70"
                        : "bg-black/20"
                } backdrop-blur-sm  sm:px-4`}
            >
                <div className="flex flex-wrap items-center justify-between mx-auto container-2xl">
                    <Link to="/" className="flex items-center mt-3 ml-2">
                        <picture>
                            <img
                                src="./img/logo.webp"
                                type="image/webp"
                                className="h-auto w-52 lg:w-96"
                            />
                        </picture>
                    </Link>

                    <div
                        id="main-nav"
                        className="items-center justify-center hidden md:block"
                    >
                        <ul className="flex flex-row items-center px-5 space-x-4 font-manrope md:space-x-8 md:mt-0 md:text-lg">
                            <li>
                                <Link
                                    to="/"
                                    className="self-center block py-2 pl-3 pr-4 font-extrabold text-white rounded link-underline hover:border-white md:hover:text-neutral-200 md:p-0"
                                >
                                    HOME
                                </Link>
                            </li>
                            <li>
                                <Link
                                    to="/menu"
                                    className="block py-2 pl-3 pr-4 font-extrabold text-white rounded link-underline md:hover:text-neutral-200 md:p-0"
                                >
                                    MENU
                                </Link>
                            </li>
                            <li>
                                <Link
                                    to="/drinks"
                                    className="block py-2 pl-3 pr-4 font-extrabold text-white rounded link-underline md:hover:text-neutral-200 md:p-0"
                                >
                                    DRINKS
                                </Link>
                            </li>

                            <li>
                                <Link
                                    to="/contact"
                                    className="block py-2 pl-3 pr-4 font-extrabold text-white rounded link-underline md:hover:text-neutral-200 md:p-0"
                                >
                                    CONTACT
                                </Link>
                            </li>
                            <li>
                                <Link
                                    to="/"
                                    state={{
                                        order: true,
                                    }}
                                >
                                    <button
                                        type="button"
                                        className="block px-5 py-3 font-extrabold leading-normal text-black bg-white border-black rounded font-manrope hover:bg-yellow-100 hover:text-black"
                                    >
                                        ORDER NOW
                                    </button>
                                </Link>
                            </li>
                        </ul>
                    </div>
                </div>
            </nav>

            <Menu
                right
                isOpen={isMenuOpen}
                burgerButtonClassName={"md:hidden"}
                crossButtonClassName={"m-3"}
                onStateChange={handleStateChange}
            >
                <Link
                    className="text-xl font-extrabold md:text-3xl text-neutral-50 font-manrope hover:text-yellow-100"
                    onClick={() => handleCloseMenu()}
                    to="/"
                >
                    HOME
                </Link>
                <Link
                    className="text-xl font-extrabold md:text-3xl text-neutral-50 font-manrope hover:text-yellow-100"
                    onClick={() => handleCloseMenu()}
                    to="/menu"
                >
                    MENU
                </Link>
                <Link
                    className="text-xl font-extrabold md:text-3xl text-neutral-50 font-manrope hover:text-yellow-100"
                    onClick={() => handleCloseMenu()}
                    to="/drinks"
                >
                    DRINKS
                </Link>

                <Link
                    className="text-xl font-extrabold md:text-3xl text-neutral-50 font-manrope hover:text-yellow-100"
                    onClick={() => handleCloseMenu()}
                    to="/contact"
                >
                    CONTACT
                </Link>
                <Link
                    className="text-xl font-extrabold md:text-3xl text-neutral-50 font-manrope hover:text-yellow-100"
                    onClick={() => handleCloseMenu()}
                    to="/"
                    state={{ order: true }}
                >
                    ORDER
                </Link>
                <div className="items-center justify-center mt-10">
                    Follow us on
                </div>
                <div className="items-center justify-center space-x-8 text-neutral-200">
                    <a
                        href="https://www.facebook.com/phodistrict106"
                        target="_blank"
                    >
                        <FaFacebook size={"2em"} />
                    </a>
                    <a
                        href="https://www.instagram.com/phodistrictt1_/"
                        target="_blank"
                    >
                        <FaInstagram size={"2em"} />
                    </a>
                </div>

                <div className="flex flex-col mt-10 text-base text-center font-manrope">
                    <Link
                        to="/"
                        className="items-center justify-center mt-3"
                        onClick={() => handleCloseMenu()}
                    >
                        <picture>
                            <img
                                src="./img/logo.webp"
                                type="image/webp"
                                className="w-60 md:w-96"
                            />
                        </picture>
                    </Link>
                    <p className="mt-3">806-407-5585</p>
                    <p className="mt-3">
                        1910 Quaker Ave Ste. #106, Lubbock, TX 79407
                    </p>

                    <p className="mt-5">© 2023 Pho District 1</p>
                    <p>All Rights Reserved.</p>
                </div>
            </Menu>
        </>
    );
}

export default Navbar;
